import _ from 'lodash'
import $ from 'jquery'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import fontSizeMenu from '../../font-size-menu'
import configBackground from '../../wob-background-menu'
import abbreviateNumbersOption from '../../abbreviate-numbers-option'
import * as commandOptions from 'scoreboard/components/rich-text/command-options'
import ColorPicker from 'scoreboard/components/color-picker'
const { PERFORMANCE } = ColorPicker
import metadata from 'scoreboard/components/metadata'

import i18n from 'scoreboard/components/i18n'
import DomainType from 'scoreboard/components/domain-type'
const { INITIATIVE, SCORECARD_ITEM } = DomainType
import opacityMenu from 'scoreboard/components/bootslide/opacity-menu'
import ShapeTextConfigView from './shape-text-config-view'
import ShapeColorConfigView from './shape-color-config-view'
import ShapeLabelConfigView from './shape-label-config-view'
import createShapePickerMenu from './create-shape-picker-menu'
import createShapeFillMenu from './create-shape-fill-menu'
import { getMenuLabel } from './shape-color-config-view'
import ShapeTextStyleOption from './shape-text-style-option'
import * as wobOutlineMenu from '../../wob-outline-menu'
import { DATA_SOURCE, NONE, SPECIFIC_TEXT } from '../shape-text-type'
import {
	SHAPE_TEXT_TYPE,
	SHAPE_TEXT_PROPERTY,
	SHAPE_TEXT_ROTATION,
	SHAPE_TEXT_ROTATION_AUTO,
	SHAPE_OPACITY,
	DATA_SOURCE_PROPERTY
} from '../shape-widget-properties'
import showPropertyToTextProperty from '../show-property-to-text-property'
import DataSourceWidgetConfigMenu from '../../data-source-widget-config-menu'
import MultipleChoiceOption from '../../multiple-choice-option'
import createPrecisionMenu from 'scoreboard/components/bootslide/create-precision-menu'

var AlignmentConfigOption = MultipleChoiceOption.extend({
	property: 'textAlign',
	defaultValue: 'center',
	choices: [{
		label: 'left',
		icons: ['align-left']
	}, {
		label: 'center',
		icons: ['align-center']
	}, {
		label: 'right',
		icons: ['align-right']
	}]
})

var ShapeConfig = DataSourceWidgetConfigMenu.extend({
	width: 210, // Wider than the default #58675

	configSize () {
		return {
			width: true,
			// #57924 line widgets can only have the "height" adjusted by using
			// the Line Width config option
			height: this.model.properties.get('shape') !== 'line'
		}
	},

	typeSpecificTargets: function (hasTemplate) {
		this.listenTo(this.model.properties, 'change:fill', () => {
			this.bootslide.toggleItem('text-color', this.model.properties.get('fill') === 'none')
			// #30125 the menu is either Set Shape Color or Set Text Color
			// depending on the value of `fill`
			this.$('[data-target-id="#bootstrap-setShapeColor"]')
				.text(getMenuLabel(this.model))
		})

		this.listenTo(this.model.properties, 'change:shape', () => {
			let isLine = this.model.properties.get('shape') === 'line'
			OPTIONS_TO_HIDE_FOR_LINES.forEach(optionId => {
				this.bootslide.toggleItem(optionId, !isLine)
			})
		})

		let targets = [
			this.createLabelConfigOption(),
			this.createShapeTextConfigOption(),
			this.createDataSourceOption({
				model: this.model,
				showDataProperty: true,
				dataPropertyOptions: ({ domainType, dataSource, domainObject }) => {
					return dataPropertyOptions({
						model: this.model,
						domainType,
						dataSource,
						domainObject
					})
				},
				dataset: this.model.dataset(),
				widgetUpdater: this.options.widgetUpdater
			}),
			this.createDisplayAndFormattingMenu(),
			configBackground(this.model.properties)
		]

		hideOptionsForLines(this.model, targets)

		return targets
	},

	createDisplayAndFormattingMenu () {
		let noShapeText = this.model.properties.get(SHAPE_TEXT_TYPE) === NONE
		let isLine = this.model.properties.get('shape') === 'line'

		let shapeFontSizeOption = fontSizeMenu(this.model.properties, {
			extraLarge: true,
			label: () => this.getShapeFontSizeMenuLabel()
		})
		shapeFontSizeOption.hidden = noShapeText
		shapeFontSizeOption.id = 'shapeTextFontSize'

		let submenu = {
			type: 'submenu',
			label: 'dashboards.displayAndFormatting',
			target: [
				// note that 'label' property isn't used for display when there
				// is a contentView, just for css classes. So no i18n is needed
				{
					id: 'shapeTextStyle',
					type: 'icons',
					label: 'styles',
					contentView: ShapeTextStyleOption,
					hidden: noShapeText
				},
				{
					id: 'shapeTextAlignment',
					type: 'icons',
					label: 'alignment',
					contentView: AlignmentConfigOption,
					hidden: noShapeText
				},
				createShapePickerMenu({
					model: this.model,
					bootslideMenu: this
				}),
				createShapeFillMenu({
					model: this.model,
					bootslideMenu: this
				}),
				this.createShapeColorConfigOption(),
				wobOutlineMenu.width(this.canvas, {
					showNoOutline: !isLine,
					label: isLine ? 'dashboards.lineThickness' : 'dashboards.shapeOutlineThickness'
				}),
				wobOutlineMenu.color(this, this.model, {
					colors: textColors({
						// Fixes #58116 - Rainbow icon should not shown for line
						// shape. The check `!isLine` ensures that performance
						// colors are only included for non-line shapes.
						includePerformance: !isLine,
						performanceValue: 'auto'
					}),
					label: isLine ? 'dashboards.lineColor' : 'dashboards.shapeOutlineColor',
					hidden: !showOutlineColorOption(this.model)
				}),
				this.createOpacitySubmenu(),
				this.createRotationSubmenu(),
				this.createOutsideTextMenu(),
				shapeFontSizeOption
			]
		}

		let outsideFontSize = fontSizeMenu(this.model.properties, {
			property: 'outsideFontSize',
			label: 'common.outsideFontSize',
			hidden: !showOutsideTextFontSizeOption(this.model)
		})
		outsideFontSize.id = 'outsideTextFontSize'
		submenu.target.push(outsideFontSize)

		this.onWidgetChange(() => {
			this.bootslide.toggleItem('outlineColor',
				showOutlineColorOption(this.model))

			this.bootslide.toggleItem('outsideTextFontSize',
				showOutsideTextFontSizeOption(this.model))

			this.bootslide.setMenuLabel('shapeTextFontSize',
				i18n.get(this.getShapeFontSizeMenuLabel()))
		})

		submenu.target.push(this.createAbbreviateNumbersOption())
		submenu.target.push(this.createPrecisionMenu())

		hideOptionsForLines(this.model, submenu.target)
		return submenu
	},

	getShapeFontSizeMenuLabel () {
		// #59829 specify "inside font size" if we're showing "outside
		// font size", otherwise stick with generic "font size"
		// Needs to be a function in case the showX options change
		return showOutsideTextFontSizeOption(this.model)
			? 'common.insideFontSize' : 'common.fontSize'
	},

	createAbbreviateNumbersOption () {
		let abbreviateNumbers = abbreviateNumbersOption(this.model)

		// #22806 only show the Abbreviate Numbers option if there is the possibility
		// of abbreviated numbers being shown
		abbreviateNumbers.hidden = !showAbbreviateNumbersOption(this.model)

		this.onWidgetChange(() => {
			this.bootslide.toggleItem('abbreviate-numbers', showAbbreviateNumbersOption(this.model))
		})

		return abbreviateNumbers
	},

	createPrecisionMenu () {
		let precisionMenu = createPrecisionMenu({
			model: this.model,
			bootslideMenu: this
		})

		precisionMenu.hidden = !showPrecisionOption(this.model)

		this.onWidgetChange(() => {
			this.bootslide.toggleItem(precisionMenu.id,
				showPrecisionOption(this.model))
		})

		this.listenTo(this.model.properties, 'change:precision', () => {
			// Adding in the checkmark for the selected precision may cause
			// it to overflow the container, so adjust the width if necessary
			this.setDynamicWidth({
				target: $(this.currentTarget),
				updateMenuWidth: true
			})
		})

		return precisionMenu
	},

	createOutsideTextMenu () {
		var showingOptions = this.model.showProperties().map(prop => {
			if (prop.type === 'submenu') {
				prop.target = prop.target.map(nestedProp =>
					this.createToggleProp(nestedProp))
				prop.width = INITIATIVE_OUTSIDE_TEXT_WIDTH
				return prop
			} else {
				return this.createToggleProp(prop)
			}
		})

		var submenu = {
			id: 'outsideText',
			type: 'submenu',
			label: 'dashboards.outsideInfo',
			target: showingOptions
		}

		if (this.model.domainType() === INITIATIVE) {
			submenu.width = INITIATIVE_OUTSIDE_TEXT_WIDTH
		}

		if (submenu.target.length === 0) {
			submenu.hidden = true
		}

		return submenu
	},

	createOpacitySubmenu () {
		let opacitySubmenu = opacityMenu({
			model: this.model.properties,
			property: SHAPE_OPACITY,
			showMaxOpacity: true,
			lineColor: 'blue-medium',
			updateModel: (value) => {
				this.options.widgetUpdater.applyUpdate(model => {
					model.setOpacity(value)
				}, { types: [ 'shape' ] })
			}
		})
		opacitySubmenu.label = i18n.get('dashboards.shapeOpacity')

		return opacitySubmenu
	},

	createRotationSubmenu () {
		this.onWidgetChange(() => {
			this.bootslide.toggleItem(SHAPE_TEXT_ROTATION,
				showTextRotationOption(this.model))
		})

		let RotationOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
			property: SHAPE_TEXT_ROTATION
		})

		let options = [SHAPE_TEXT_ROTATION_AUTO, 0, 90, 180, 270]
			.map(rotation => {
				return {
					contentView: RotationOption.extend({
						value: rotation,
						label: i18n.get(rotation == SHAPE_TEXT_ROTATION_AUTO
							? 'common.auto'
							: 'dashboards.textRotation.' + rotation)
					}),
					model: this.model.properties
				}
			})

		return {
			id: SHAPE_TEXT_ROTATION,
			type: 'submenu',
			label: 'dashboards.textRotation',
			hidden: !showTextRotationOption(this.model),
			target: options
		}
	},

	createToggleProp: function(prop) {
		return {
			label: prop.label,
			contentView: BootslideMenu.WidgetToggleProperty.extend({
				property: {label: prop.label, name: prop.property}
			}),
			model: this.model.properties
		}
	},

	createShapeTextConfigOption () {
		return this.simpleDialogOption({
			ConfigViewClass: ShapeTextConfigView,
			label: 'dashboards.setText',
			id: 'setShapeText'
		})
	},

	createShapeColorConfigOption () {
		return this.simpleDialogOption({
			ConfigViewClass: ShapeColorConfigView,
			label: getMenuLabel(this.model),
			id: 'setShapeColor',
			onDone: (result) => {
				// This updates model.properties and model.wob, so use a single
				// transaction for undo/redo purposes
				this.model.trigger('transaction', () => {
					this.options.widgetUpdater.applyUpdate(widgetModel => {
						let update
						if (widgetModel === this.model) {
							update = result
						} else {
							update = _.cloneDeep(result)
							// #57903 any other widgets using the same
							// thresholdColoring settings need to have their
							// own copy of it. Clear out the ID so the server
							// will save it as a new record
							delete update?.thresholdColoring?.id
						}
						widgetModel.setColor(update)
					}, ['shape'])
				})
			}
		})
	},

	createLabelConfigOption () {
		return this.simpleDialogOption({
			ConfigViewClass: ShapeLabelConfigView,
			label: 'dashboards.setTitle',
			id: 'setLabel',
			// This is a noop because ShapeLabelConfigView directly updates
			// the widget model
			onDone: () => {}
		})
	},

	simpleDialogOption ({ ConfigViewClass, label, id, onDone }) {
		const viewCreator = () => {
			return new ConfigViewClass({
				model: this.model,
				widgetUpdater: this.options.widgetUpdater
			})
		}

		if (!onDone) {
			onDone = (updatedProperties) => {
				this.options.widgetUpdater.setProperties(updatedProperties)
			}
		}

		let target = BootslideMenu.targetOption(
			label, viewCreator, onDone)

		target.type = 'dialog'
		target.id = id

		return target
	},

	/**
	 * Registers an event listener for changes the Backbone Models related to
	 * this widget.
	 *
	 * @param {Function} action
	 */
	onWidgetChange (action) {
		this.listenTo(this.model.properties, 'change', action)
		this.listenTo(this.model.wob, 'change', action)
	}
})

function textColors ({
	includePerformance = true, performanceValue = PERFORMANCE } = {}) {
	let colors = _.cloneDeep(commandOptions.rawColors())

	if (includePerformance) {
		let lastGroup = colors[colors.length - 1]
		lastGroup.push(...ColorPicker.buildPerformanceOption(
			false, performanceValue))
	}

	return colors
}

/**
 * Returns true if the bubble is configured to allow text rotation to be changed.
 */
function showTextRotationOption (model) {
	// For explanation of hiding config when shape is invisible, see:
	// https://github.com/SpiderStrategies/Scoreboard/issues/17619#issuecomment-2007859976
	return model.isShapeVisible()
		&& model.properties.get(SHAPE_TEXT_TYPE) !== NONE
}

/**
 * Returns true if the outlineWidth has been set on the wob
 */
function showOutlineColorOption (model) {
	return !_.isNil(model.wob.get('outlineWidth'))
}

/**
 * Returns true if no outside info is enabled/showing
 */
function showOutsideTextFontSizeOption (model) {
	return _(model.flatShowProperties())
		.filter(p => p.property !== 'showTrend')
		.some(p => !!model.properties.get(p.property))
}

/**
 * Returns true if the bubble is configured to show numbers that could be
 * abbreviated. For example, Actual Value could be abbreviated to "143K",
 * but Score will never be abbreviated.
 */
function showAbbreviateNumbersOption (model) {
	if (model.isNoneSource()) {
		// "None" sources never have any numeric values, so there's never anything
		// to abbreviate
		return false
	}

	if (model.properties.get('shape') === 'line') {
		return false
	}

	let toggledOnProperties = _(model.properties.toJSON())
		.toPairs()
		.filter(([prop, value]) => prop.indexOf('show') === 0 && !!value)
		.map(([prop, value]) => prop).value()

	if (_.intersection(toggledOnProperties, POSSIBLY_ABBREVIATED_PROPS).length > 0) {
		return true
	}

	// If no numeric values in the Outside Info, check the shape text

	let shapeTextType = model.properties.get(SHAPE_TEXT_TYPE)
	if (shapeTextType === NONE || shapeTextType === SPECIFIC_TEXT) {
		// No numeric values in the shape text
		return false
	}

	// There's data in the shape text, so we need to check if it can be abbreviated
	if (model.isDatasetSource()) {
		// The data for datasets is always numeric, so we can always abbreviate
		return true
	} else {
		let propertyToCheck = shapeTextType === DATA_SOURCE
			? model.properties.get(DATA_SOURCE_PROPERTY)
			: model.properties.get(SHAPE_TEXT_PROPERTY)

		// For scorecards and initiatives, we can use the same rules as the
		// showX properties, just tweaked for the
		// shapeTextProperty/dataSourceProperty format
		return POSSIBLY_ABBREVIATED_SHAPE_TEXT_PROPERTIES.includes(propertyToCheck)
	}
}

function showPrecisionOption (model) {
	// #61863 for 5.7.0, we're hiding the precision option for all
	// initiative sources. That will be changed in 5.7.1 in #61549
	if (model.domainType() === INITIATIVE) {
		return false
	}

	// #61839 Precision option is tied to the Abbreviate Numbers option, so
	// if that's hidden, this should be too
	if (!showAbbreviateNumbersOption(model)) {
		return false
	}

	// If numbers are abbreviated, then there won't be any decimals anyway, so
	// don't show the precision option
	return !model.properties.get('showAbbreviatedNumbers')
}

// showX properties that could result in abbreviated numbers (eg '$143K') being displayed
const POSSIBLY_ABBREVIATED_PROPS = [ 'showActual', 'showBudget',
	'showBudgetRemaining', 'showBudgetSpent',
	'showBudgetVariance', 'showBudgetVariancePercent', 'showPercentTimeElapsed',
	'showProjectedBudget', 'showGoal' ]

const POSSIBLY_ABBREVIATED_SHAPE_TEXT_PROPERTIES =
	POSSIBLY_ABBREVIATED_PROPS.map(showPropertyToTextProperty)

const NON_NUMERIC_PROPERTIES = [
	'label',
	'description',
	'period',
	'color',
	'schedule',
	'budget',
	'start-date',
	'end-date',
	'projected-end-date'
]

/**
 * Returns the options valid for the "Field" (ie dataProperty) dropdown in the
 * Set Data Source dialog.
 */
function dataPropertyOptions ({ model, domainType, dataSource, domainObject }) {
	// ShapeModel.validShapeTextPropertyOptions() is the easiest and most accurate
	// way to get a list of all valid properties for the selected object, but
	// we don't want to mutate the model until the user clicks "Done". So just
	// create a copy of the model and update that instead.
	//
	// Note: using model.constructor instead of ShapeModel to avoid
	// circular dependencies
	const section = metadata[domainType].section
	const attributes = _.cloneDeep(model.attributes)
	attributes.properties.section = section

	let tmpModel = new model.constructor(attributes, {
		domainObject,
		section,
		getPeriodId: model.options.getPeriodId
	})
	tmpModel.setDataSource({ domainType, dataSource })

	return tmpModel.validShapeTextPropertyOptions()
		.filter(o => {
			return !_.includes(NON_NUMERIC_PROPERTIES, o.value) &&
				o.value !== 'weight'
		})
		.map(o => {
			return {
				id: o.value,
				label: o.label
			}
		})
}

/**
 * The width of the "Outside Text" menu for initiative data sources.
 *
 * We've had trouble getting bootslide to dynamically grow to the correct width,
 * so we decided to just hard-code it where necessary.
 * https://github.com/SpiderStrategies/Scoreboard/issues/4147
 */
const INITIATIVE_OUTSIDE_TEXT_WIDTH = 325

/**
 * If the given shape model is a line shape, sets `hidden: true` for any options
 * that are not valid for lines
 */
function hideOptionsForLines (model, targets) {
	if (model.properties.get('shape') !== 'line') {
		return
	}

	targets.forEach(t => {
		if (OPTIONS_TO_HIDE_FOR_LINES.includes(t.id)) {
			t.hidden = true
		}
	})
}

const OPTIONS_TO_HIDE_FOR_LINES = [
	'shape-fill', 'setDataSource', 'setLabel', 'setShapeText', 'setShapeColor',
	'background', 'shapeTextStyle', 'shapeTextAlignment', SHAPE_TEXT_ROTATION,
	'outsideText', 'shapeTextFontSize', 'outsideTextFontSize',
	// #57941 can't change shape type for lines
	'shape'
]

export default ShapeConfig
export { textColors, showAbbreviateNumbersOption, showTextRotationOption,
	dataPropertyOptions, showOutlineColorOption, showOutsideTextFontSizeOption }

ShapeConfig.__filename__ = 'dashboards/widgets/shape/config/shape-config.js'
